import { styled } from '@linaria/react';

interface SpinnerContainerProps {
    centered?: boolean;
}

interface SpinnerProps {
    size?: 'small' | 'medium' | 'large';
}

export const SpinnerContainer = styled.div<SpinnerContainerProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding: 2rem;
    ${props => props.centered && `
        justify-content: center;
        min-height: 200px;
    `}
`;

const sizeMap = {
    small: '24px',
    medium: '40px',
    large: '64px'
};

export const Spinner = styled.div<SpinnerProps>`
    width: ${props => sizeMap[props.size || 'medium']};
    height: ${props => sizeMap[props.size || 'medium']};
    border: 3px solid #f3f3f3;
    border-top: 3px solid #007bff;
    border-radius: 50%;
    animation: spin 1s linear infinite;

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

export const LoadingText = styled.div`
    color: #6c757d;
    font-size: 0.875rem;
    font-weight: 500;
`;
